
import moment from "moment";

export default function getSlaLabel(date) {
    const diff = moment(date).diff(moment(), "days");


    if (diff < 0) {
        return { labelClass: "label label-danger", labelText: "SLA datum har passerat" }
    }
    else if (diff <= 1) {
        return { labelClass: "label label-danger", labelText: "SLA går ut om mindre än 1 dag" };
    }
    else if (diff <= 5) {
        return { labelClass: "label label-orange", labelText: "SLA går ut om mindre än 5 dagar" }
    }
    else if (diff <= 10) {
        return { labelClass: "label label-warning", labelText: "SLA går ut om mindre än 10 dagar" }
    }
    else if (diff <= 31) {
        return { labelClass: "label label-blue", labelText: "SLA går ut om mindre än 31 dagar" }
    }

    return { labelClass: "", labelText: "" }
}